export const CURRENT_USER = 'currentUser';
export const IS_NAV_COLLAPSED = 'isNavCollapsed';
